import apiClient from "./apiClient";

export async function getWahuStats() {
    const response = await apiClient.get(`api/wahu.php/wahu_dashboard`);
    const responseClone = response.clone();
    console.log("response closnse",await responseClone.text())
    try {
        return await response.json();
    } catch (e) {
        console.log("getWahuStats threw error", await responseClone.text());
        return {};
    }
}

export async function login(credentials) {
    try {
        // const response = await apiClient.post("/login", credentials);
        const response = await apiClient.post("/auth/login", credentials);
        return response;
    } catch (e) {
        console.log("login threw error");
        return {};
    }
}

export async function reset_password(credentials) {
    try {
        const response = await apiClient.put("/auth/password", credentials);
        return response;
    } catch (e) {
        console.log("reset_password threw error");
        return {};
    }
}

export async function change_buddy_status(buddy_id, newStatus) {
    try {
        const response = await apiClient.put(`/buddies/${buddy_id}`, { status: newStatus });
        return response;
    } catch (e) {
        console.log("change_buddy_status threw error");
        return {};
    }
}

export async function createVehicleServiceTicket(service_list) {
    try {
        const response = await apiClient.post("/tickets/service", service_list);
        return response;
    } catch (e) {
        console.log("createVehicleServiceTicket threw error");
        return {};
    }
}

export async function createOrderTicket(service_list) {
    try {
        const response = await apiClient.post("/tickets/order", service_list);
        return response;
    } catch (e) {
        console.log("createOrderTicket threw error");
        return {};
    }
}

export async function updateServiceTicketStatus(service_id, status) {
    try {
        const response = await apiClient.put(`/tickets/service/${service_id}`, { status });
        return response;
    } catch (e) {
        console.log("updateServiceTicketStatus threw error");
        return {};
    }
}

export async function updateOrderTicketStatus(order_id, status) {
    try {
        const response = await apiClient.put(`/tickets/order/${order_id}`, { status });
        return response;
    } catch (e) {
        console.log("updateOrderTicketStatus threw error");
        return {};
    }
}

export async function editVehicleServiceTicket(service_id, service_list) {
    try {
        const response = await apiClient.put(`/tickets/service/${service_id}`, service_list);
        return response;
    } catch (e) {
        console.log("editVehicleServiceTicket threw error");
        return {};
    }
}

export async function editOrderTicket(order_id, service_list) {
    try {
        const response = await apiClient.put(`/tickets/order/${order_id}`, service_list);
        return response;
    } catch (e) {
        console.log("editOrderTicket threw error", e);
        return {};
    }
}

export async function addCustomer(memberData) {
    try {
        const response = await apiClient.post("/customers", memberData);
        return response;
    } catch (e) {
        console.log("addCustomer threw error");
        return {};
    }
}

export async function addCustomerVehicle(vehicleData) {
    try {
        const response = await apiClient.post("/vehicles", vehicleData);
        return response;
    } catch (e) {
        console.log("addCustomerVehicle threw error");
        return {};
    }
}

export async function addCustomerNote(payload) {
    try {
        const response = await apiClient.post("/notes", { ...payload, type: "customer" });
        return response;
    } catch (e) {
        console.log("addCustomerNote threw error");
        return {};
    }
}

export async function addVehicleNote(payload) {
    try {
        const response = await apiClient.post("/notes", { ...payload, type: "vehicle" });
        return response;
    } catch (e) {
        console.error("addVehicleNote threw error");
        return {};
    }
}

export async function addBuddy(buddyData) {
    try {
        const response = await apiClient.post("/buddies", buddyData);
        return response;
    } catch (e) {
        console.log("addBuddy threw error");
        return {};
    }
}

export async function addSubscription(subscriptionData) {
    try {
        const response = await apiClient.post("/subscriptions", subscriptionData);
        return response;
    } catch (e) {
        console.log("addSubscription threw error");
        return {};
    }
}

export async function addMembershipPayment(payload) {
    try {
        const response = await apiClient.post("/payments", { ...payload, ticket_type: "membership" });
        return response;
    } catch (e) {
        console.log("addMembershipPayment threw error");
        return {};
    }
}

export async function addTicketPayment(payload) {
    try {
        const response = await apiClient.post("/payments", payload);
        return response;
    } catch (e) {
        console.log("addTicketPayment threw error");
        return {};
    }
}

export async function deleteServiceTicket(ticket_id) {
    const response = await apiClient.delete(`/tickets/service/${ticket_id}`);
    const responseClone = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("deleteServiceTicket threw error", await responseClone.text());
        return {};
    }
}

export async function deleteOrderTicket(ticket_id) {
    const response = await apiClient.delete(`/tickets/order/${ticket_id}`);
    const responseClone = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("deleteOrderTicket threw error", await responseClone.text());
        return {};
    }
}

export async function getCustomerDetails(customer_id) {
    const response = await apiClient.get(`/customers/${customer_id}`);
    const responseCopy = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("getCustomerDetails threw error", await responseCopy.text());
        return {};
    }
}

export async function getSubscriptionHistory(customer_id = null) {
    const url = customer_id === null
        ? "/subscriptions/history"
        : `/subscriptions/history?customer_id=${customer_id}`;
    const response = await apiClient.get(url);
    const responseCopy = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("getSubscriptionHistory threw error", await responseCopy.text());
        return {};
    }
}

export async function getOrderTicket(order_id) {
    const response = await apiClient.get(`/tickets/order/${order_id}`);
    const responseCopy = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("getOrderTicket threw error", await responseCopy.text());
        return {};
    }
}

export async function getCustomerServices(customer_id) {
    const response = await apiClient.get(`/customers/${customer_id}/services`);
    const responseCopy = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("getCustomerServices threw error", await responseCopy.text());
        return {};
    }
}

export async function getServiceDetails(service_id) {
    const response = await apiClient.get(`/tickets/service/${service_id}`);
    const responseCopy = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("getServiceDetails threw error", await responseCopy.text());
        return {};
    }
}

export async function getOrderDetails(order_id) {
    const response = await apiClient.get(`/tickets/order/${order_id}`);
    const responseCopy = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("getOrderDetails threw error", await responseCopy.text());
        return {};
    }
}

export async function getSubscription_plans() {
    const response = await apiClient.get("/subscriptions");
    const responseCopy = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("getSubscription_plans threw error", await responseCopy.text());
        return {};
    }
}

export async function getDashboardStats(startPeriod = null, endPeriod = null) {
    const currentYear = new Date().getFullYear();
    const start = new Date(currentYear, 0, 1);
    const end = new Date(currentYear, 11, 31);
    const url = `/dashboard?start=${(startPeriod ?? start).toISOString()}&end=${(endPeriod ?? end).toISOString()}`;
    const response = await apiClient.get(url);
    const responseCopy = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("getDashboardStats threw error", await responseCopy.text());
        return {};
    }
}

export async function getVehicleDetails(id) {
    const response = await apiClient.get(`/vehicles/${id}`);
    const responseCopy = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("getVehicleDetails threw error", await responseCopy.text());
        return {};
    }
}

export async function getVehicleServiceHistory(id) {
    const response = await apiClient.get(`/vehicles/${id}`);
    const responseCopy = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("getVehicleServiceHistory threw error", await responseCopy.text());
        return {};
    }
}

export async function getCustomerNotes(id) {
    const response = await apiClient.get(`/notes?type=customer&parent_id=${id}`);
    const responseCopy = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("getCustomerNotes threw error", await responseCopy.text());
        return {};
    }
}

export async function getVehicleNotes(id) {
    const response = await apiClient.get(`/notes?type=vehicle&parent_id=${id}`);
    const responseClone = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("getVehicleNotes threw error", await responseClone.text());
        return {};
    }
}

export async function getBuddies() {
    const response = await apiClient.get("/buddies");
    const responseCopy = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("getBuddies threw error", await responseCopy.text());
        return {};
    }
}

export async function getAllTickets() {
    const response = await apiClient.get("/tickets");
    const responseClone = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("getAllTickets threw error", await responseClone.text());
        return {};
    }
}

export async function getServiceTicketItems(ticket_id) {
    const response = await apiClient.get(`/tickets/service/${ticket_id}/items`);
    const responseClone = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("getServiceTicketItems threw error", await responseClone.text());
        return {};
    }
}

export async function getOrderTicketItems(ticket_id) {
    const response = await apiClient.get(`/tickets/order/${ticket_id}/items`);
    const responseClone = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("getOrderTicketItems threw error", await responseClone.text());
        return {};
    }
}

export async function getBuddyDetails(buddy_id) {
    const response = await apiClient.get(`/buddies/${buddy_id}`);
    const responseClone = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("getBuddyDetails threw error", await responseClone.text());
        return {};
    }
}

export async function getModels() {
    const response = await apiClient.get("/options/vehicle-models");
    const responseClone = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("getModels threw error", await responseClone.text());
        return {};
    }
}

export async function getMembershipPlans() {
    const response = await apiClient.get("/members/plans");
    const responseClone = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("getMembershipPlans threw error", await responseClone.text());
        return {};
    }
}

export async function _getServiceItems() {
    const response = await apiClient.get("/services");
    const responseClone = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("_getServiceItems threw error", await responseClone.text());
        return {};
    }
}

export async function _getOrderItems() {
    const response = await apiClient.get("/options/order-items");
    const responseClone = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("_getOrderItems threw error", await responseClone.text());
        return {};
    }
}

export async function _getPaymentMethods() {
    const response = await apiClient.get("/options/payment-methods");
    const responseClone = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("_getPaymentMethods threw error", await responseClone.text());
        return {};
    }
}

export async function _getTicketStatusOptions() {
    try {
        const response = await apiClient.get("/options/statuses");
        const responseCopy = response.clone();
        try {
            return await response.json();
        } catch {
            console.log("response", await responseCopy.text());
            return {};
        }
    } catch (e) {
        console.log("_getTicketStatusOptions threw error", e);
        return {};
    }
}

export async function _getTicketTagOptions() {
    try {
        const response = await apiClient.get("/options/tags");
        return await response.json();
    } catch (e) {
        console.log("_getTicketTagOptions threw error", e);
        return {};
    }
}

export async function getCustomers() {
    const response = await apiClient.get("/customers");
    const responseClone = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("getCustomers threw error", await responseClone.text());
        return {};
    }
}

export async function getCustomerByName(query) {
    const response = await apiClient.get(`/customers/search?q=${query}`);
    const responseCopy = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("getCustomerByName threw error", await responseCopy.text());
        return {};
    }
}

export async function getMembers() {
    const response = await apiClient.get("/members");
    const responseClone = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("getMembers threw error", await responseClone.text());
        return {};
    }
}

export async function getVehicles() {
    const response = await apiClient.get("/vehicles");
    const responseClone = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("getVehicles threw error", await responseClone.text());
        return {};
    }
}

export async function getCustomerVehicles(customer_id) {
    const response = await apiClient.get(`/customers/${customer_id}/vehicles`);
    const responseClone = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("getCustomerVehicles threw error", await responseClone.text());
        return {};
    }
}

export async function createPaystackInvoice(ticket_id, ticket_type) {
    try {
        const response = await apiClient.post("/payments/paystack/invoice", {
            ticket_id,
            ticket_type
        });
        return response;
    } catch (e) {
        console.log("createPaystackInvoice threw error");
        return {};
    }
}

export async function sendPaystackInvoiceNotification(payload) {
    try {
        const response = await apiClient.post("/email/paystack-invoice", payload);
        return response;
    } catch (e) {
        console.log("sendPaystackInvoiceNotification threw error");
        return {};
    }
}

export async function sendFeedbackEmail(emailData) {
    try {
        const response = await apiClient.post("/email/feedback", emailData);
        return response;
    } catch (e) {
        console.log("sendFeedbackEmail threw error");
        return {};
    }
}

export async function sendExpiryNotification(notificationData) {
    try {
        const response = await apiClient.post("/email/expiry-notification", notificationData);
        return response;
    } catch (e) {
        console.log("sendExpiryNotification threw error");
        return {};
    }
}

export async function sendReceivedByEmail(emailData) {
    try {
        const response = await apiClient.post("/email/vehicle-receipt", emailData);
        return response;
    } catch (e) {
        console.log("sendReceivedByEmail threw error");
        return {};
    }
}

export async function sendNextServiceNotification(emailData) {
    try {
        const response = await apiClient.post("/email/next-service", emailData);
        return response;
    } catch (e) {
        console.log("sendNextServiceNotification threw error");
        return {};
    }
}

export async function getEmailTemplates() {
    const response = await apiClient.get("/templates");
    const responseClone = response.clone();
    try {
        return await response.json();
    } catch (e) {
        console.log("getEmailTemplates threw error", await responseClone.text());
        return {};
    }
}

export async function getEmailTemplate(templateName) {
    try {
        const response = await apiClient.get(`/templates/${templateName}`);
        const responseClone = response.clone();
        try {
            return await response.json();
        } catch (e) {
            console.log("getEmailTemplate threw error", await responseClone.text());
            return {};
        }
    } catch (e) {
        console.log("getEmailTemplate threw error");
        return {};
    }
}

export async function sendEmailWithTemplate(emailData) {
    try {
        const response = await apiClient.post("/templates/send", emailData);
        const responseClone = response.clone();
        try {
            return await response.json();
        } catch (e) {
            console.log("sendEmailWithTemplate threw error", await responseClone.text());
            return {};
        }
    } catch (e) {
        console.log("sendEmailWithTemplate threw error");
        return {};
    }
}

export async function getRoutineServices() {
    try {
        const response = await apiClient.get("/options/routine-services");
        return await response.json();
    } catch (e) {
        console.log("getRoutineServices threw error", e);
        return {};
    }
}
